export const CrudRoutesWithRouteParam = ['clone', 'view', 'edit'];
export function isCrudModeWithRouteParam(mode) {
  return CrudRoutesWithRouteParam.includes(mode);
}
export var CrudManagerUtils;
(function (CrudManagerUtils) {
  function getContextGroups(mode) {
    const groups = ['crud', mode];
    if (mode !== 'list') groups.push('editor');
    return groups;
  }
  CrudManagerUtils.getContextGroups = getContextGroups;
})(CrudManagerUtils || (CrudManagerUtils = {}));